/* Copyright © 2026 Xerox Corporation. All Rights Reserved. Copyright protection claimed includes all forms and matters of copyrightable material and information now allowed by statutory or judicial law or hereinafter granted, including without limitation, material generated from the software programs which are displayed on the screen such as icons, screen display looks, etc. */

import { Component, OnInit, OnDestroy } from '@angular/core';
import { UserService } from '../../services/user.service';
import { Subscription } from 'rxjs/internal/Subscription';
import { Constants } from '../../../common/constants';
@Component({
  selector: 'nav-footer',
  templateUrl: './nav-footer.component.html',
  styleUrls: ['../../../styles/appTheme-xids.scss'],
  standalone: false,
})
export class NavFooterComponent implements OnInit, OnDestroy {
  mailToUrl = '';
  supportURL = '';
  softwareDisclosureUrl = '../documents/software-disclosure.txt';
  secGuideUrl =
    'https://security.business.xerox.com/en-us/products/xerox-workflow-central-platform/';
  documentationUrl =
    'https://www.support.xerox.com/en-us/product/xerox-workflow-central-service/documentation';
  privacyUrl = 'https://www.xerox.com/privacy';
  isSubUser = false;
  private accessListDiscoveredSub: Subscription;
  private userLogoutSub: Subscription;
  private userAuthSub: Subscription;

  constructor(private userService: UserService) {}

  ngOnInit(): void {
    if (this.userService.isLoggedOn()) {
      this.isSubUser = this.userService?.user?.isSubscriptionUser ?? false;
    }
    this.accessListDiscoveredSub = this.userService.discovered.subscribe(
      () => {
        this.isSubUser = this.userService?.user?.isSubscriptionUser ?? false;
        this.setSupportUrl();
      }
    );
    this.userAuthSub = this.userService.userAuthenticated.subscribe(
      () => {
        this.isSubUser = this.userService?.user?.isSubscriptionUser ?? false;
        this.setSupportUrl();
      }
    );
    this.userLogoutSub = this.userService.userLoggedOff.subscribe(
      () => (this.isSubUser = false),
    );
    if (window.navigator.language.toLowerCase() == 'pt-br') {
      this.privacyUrl = 'https://www.xerox.com/pt-br/sobre-nos/privacy-policy';
    }

    this.setSupportUrl();
  }

  setSupportUrl()
  {
    // set the support URL based on the user's language
    if (this.userService.user?.language.toLowerCase() === 'no') {
      // make sure we use the correct language code/region code for Norwegian
      this.supportURL =
        'https://www.support.xerox.com/no-no/product/xerox-workflow-central-service/contact';
    } else if (this.userService.user?.language.toLowerCase() === 'ca') {
      // xerox.com doesn't support catalan, so default to english
      this.supportURL =
        'https://www.support.xerox.com/en-us/product/xerox-workflow-central-service/contact';
    } else if (this.userService.user?.language.toLowerCase() === 'ru') {
      // xerox.com doesn't support russian, so default to english
      this.supportURL =
        'https://www.support.xerox.com/en-us/product/xerox-workflow-central-service/contact';
    } else {
      // for all other languages find the correct language/region code in the Constants.languages list based on the user's language with a fallback to english.
      const languageCode = Constants.languages
        .find(
          (lang) =>
            lang.ISOCode.toLowerCase() ===
            this.userService.user?.language.toLowerCase(),
        )
        ?.regionCode.toLowerCase();
      this.supportURL = `https://www.support.xerox.com/${languageCode ?? 'en-us'}/product/xerox-workflow-central-service/contact`;
    }
  }

  ngOnDestroy() {
    this.accessListDiscoveredSub.unsubscribe();
    this.userLogoutSub.unsubscribe();
    this.userAuthSub.unsubscribe();
  }
}
